export enum NubankPaymentEvent {
  GO_TO_PAYMENT_ENROLLMENT_SUCCESS = "GO_TO_PAYMENT_ENROLLMENT_SUCCESS",
  GO_TO_PAYMENT_ENROLLMENT_FAILURE = "GO_TO_PAYMENT_ENROLLMENT_FAILURE",
}

export interface IPaymentEventResponse {
  type: NubankPaymentEvent;
  /** Authorization code from Nupay direct OAuth callback (present on success) */
  authorizationCode?: string;
  /** Raw OAuth state string from NuPay callback (includes BFF-injected csrfToken) */
  nupayOAuthState?: string;
}
